// import './candidates/candidates';
// import './notprocessedcandidates/notprocessedcandidates';
import './reports/reports';
import './reports/candidateperformance/candidateperformance';
import './reports/corporateorclientreports/corporateorclientreports';
import './reports/requisitionperformance/requisitionperformance';
import './reports/sourcingperformance/sourcingperformance';
import './reports/teammembersperformance/teammemberperformance';
import './reports/teammembersperformance/bymeasures/performancebymeasures';
import './reports/teammembersperformance/byteammember/performancebyteammember';
// import './usermanagement/usermanagement';
//unused
// import './valueassessment/bigfive';
// import './auditlogs/auditlogs';
// import './transactions/transactions';
//# sourceMappingURL=index.js.map